import { alpha, Card, Grid, styled } from "@mui/material";
import { useContext } from "react";
import palette from "src/theme/palette";
import { ActivePosition } from "src/types/products";

import Context from "../../../context";
import PositionItemName from "./PositionItemName";
import SharesResult from "./RevisionResult";

// ----------------------------------------------------------------------

const CustomCard = styled(Card)<{
	contentBackgroundColor?: string;
	type: string;
}>(({ contentBackgroundColor, type }) => {
	const shadowColor = type === "dark" ? "#000000" : palette.light.grey[500];
	return {
		backgroundColor: contentBackgroundColor,
		boxShadow: `0 0 2px 0 ${alpha(shadowColor, 0.2)}, 0 12px 24px -4px ${alpha(shadowColor, 0.12)}`
	};
});

type Props = {
	position: ActivePosition;
};

export const RevisionItem = ({ position }: Props) => {
	const { theme, themeType } = useContext(Context);
	const { titles, localPrice, localCurrency, positionId } = position;

	return (
		<CustomCard
			sx={{ px: 2, py: 1.5 }}
			contentBackgroundColor={theme?.colors.contentBackground}
			type={themeType}
		>
			<Grid
				container
				rowSpacing={0.5}
				sx={{ mb: 0.5 }}
				alignItems={"center"}
				justifyContent={"space-between"}
			>
				<Grid item>
					<PositionItemName positionId={positionId} />
				</Grid>
				<Grid item>
					<SharesResult shares={titles} amount={localPrice} currency={localCurrency} />
				</Grid>
			</Grid>
		</CustomCard>
	);
};

export default RevisionItem;
